import styled from "../styles/styled"

const Box = styled("div")({})

export default Box
